import React from 'react';
import styled, { css } from 'styled-components';
import { Spacing } from '../Spacing';
import { media } from '../themes/theme';
import { Headline1, Paragraph } from '../../src/atoms/Typography';
const CtaContainer = styled.div `
  display: grid;
  margin-top: 1.25rem;
  align-items: center;
  justify-items: center;
  grid-template-columns: ${props => props.isSmallStage ? 'max-content max-content' : 'none'};
  grid-template-rows: ${props => props.isSmallStage ? 'none' : 'max-content max-content'};
  grid-gap: ${props => (props.isSmallStage ? '2rem' : '1rem')};

  ${media.mobileXL `
    grid-template-columns: max-content max-content;
    grid-template-rows: none;
    grid-gap: 2rem;
  `}
`;
const StageContentInner = styled.div `
  display: flex;
  flex-direction: column;
  hyphens: manual;

  ${props => !props.isSmallStage &&
    css `
      align-items: center;
      text-align: center;
    `}

  ${media.mobileXL `
    all: unset;
    hyphens: manual;
  `}
`;
export function StageContent({ className, headline, text = undefined, children = null, isSmallStage = false, headlineColor = 'darkergrey', textColor = 'darkergrey', }) {
    return (React.createElement(StageContentInner, { className: className, isSmallStage: isSmallStage },
        React.createElement(Headline1, { color: headlineColor }, headline),
        text && (React.createElement(Spacing, { mt: "spacing-xs" },
            React.createElement(Paragraph, { color: textColor }, text))),
        children && (React.createElement(CtaContainer, { isSmallStage: isSmallStage }, children))));
}
